import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { ConfirmDialog } from "components/common";
import { useEnableDetectionChain } from "../../hooks/useDetectionChainsAPI";
const EnableChainAction = ({ chain }) => {
  const { t } = useTranslation("enterprise_security_sigma");
  const [showConfirm, setShowConfirm] = useState(false);
  const { mutate: enableChain, isPending: inFlight } = useEnableDetectionChain();
  const total = chain.definitions_count;
  const enabled = chain.enabled_definitions_count;
  const remaining = total - enabled;
  const empty = total === 0;
  const allEnabled = !empty && remaining === 0;
  let label;
  if (inFlight) label = t("enable_chain.enabling");
  else if (allEnabled) label = t("enable_chain.all_enabled");
  else if (enabled > 0) label = t("enable_chain.enable_remaining", { remaining });
  else label = t("enable_chain.enable_chain");
  const onConfirm = () => {
    enableChain(chain.name);
    setShowConfirm(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xsmall",
      bsStyle: allEnabled ? "success" : "default",
      onClick: () => setShowConfirm(true),
      disabled: inFlight || empty || allEnabled,
      "data-testid": `enable-chain-${chain.name}`
    },
    label
  ), showConfirm && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: t("enable_chain.confirm_title"),
      show: true,
      onConfirm,
      onCancel: () => setShowConfirm(false)
    },
    t("enable_chain.confirm_message", { count: remaining, name: chain.name })
  ));
};
export default EnableChainAction;
